import api from './client'
import { invalidateCache } from '../../utils/cache'

export const getCategories = (forceRefresh = false, requestConfig = {}) => {
  return api.get('/categories', { useCache: !forceRefresh, ...requestConfig }).then((res) => res.data)
}

export const addCategory = async (data) => {
  const response = await api.post('/categories', data).then((res) => res.data)
  invalidateCache('/categories')
  return response
}

export const deleteCategory = async (nom) => {
  const response = await api
    .delete(`/categories/${encodeURIComponent(nom)}`)
    .then((res) => res.data)
  invalidateCache('/categories')
  return response
}
